import React, { useState } from "react";
import { Tabs, Tab, Box,Grid } from "@mui/material";
import CreateUser from "./CreateUser";
import UserList from "./UserList";

// TabPanel Component to Render Content
const TabPanel = ({ children, value, index }) => {
  return (
    <div hidden={value !== index}>
      {value === index && <Box sx={{ p: 2 }}>{children}</Box>}
    </div>
  );
};

// Main Tabs Component
const CreateUserTabs = () => {
  const [tabIndex, setTabIndex] = useState(0);

  const handleTabChange = (event, newValue) => {
    setTabIndex(newValue);
  };

  return (
    <Box sx={{ width: "100%" }}>
      {/* Tab Headers */}
      <Grid container sx={{padding:"10px"}}>
        <Grid item xs= {7} sm ={3} md = {3} lg ={2} xl={3} sx={{padding:"8px",background:"#F5F8FF",borderRadius:"8px"}}>
        <Tabs
          value={tabIndex}
          onChange={handleTabChange}
          sx={{
            "& .MuiTabs-indicator": {
              display: "none",
            },
          }}
        >
          <Tab
            label="All Users"
            style={{
              textTransform: "capitalize",
              background: tabIndex === 0 ? "#0FA5D9" : "white",
              color: tabIndex === 0 ? "white" : "#707EAE",
              borderRadius: "8px",
            }}
          />
          <Tab
            label="Create User"
            style={{
                textTransform: "capitalize",
                background: tabIndex === 1 ? "#0FA5D9" : "white",
                color: tabIndex === 1 ? "white" : "#707EAE",
                borderRadius: "8px",
              }}
            />
        </Tabs>
        </Grid>
        </Grid>

      {/* Tab Panels */}
      <TabPanel value={tabIndex} index={0}>
        <UserList />
      </TabPanel>
      <TabPanel value={tabIndex} index={1} >
        <CreateUser setTabIndex={setTabIndex}/>
      </TabPanel>
    </Box>
  );
};

export default CreateUserTabs;
